/* VERO LUX — Polyphenol reveal: pinned, scroll-driven scene (bottle rises upright, lab gauge fills, 10x counts). */
(function () {
  var d = document, w = window;
  function init() {
    if (!d.body || !d.body.classList.contains('lux')) return;
    if (w.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var sec = d.querySelector('#MainContent [class^="vero-polyphenol-section-"]');
    if (!sec || sec.classList.contains('lx-pp')) return;
    var q = function (s) { return sec.querySelector(s); };
    var cont = q('[class^="vero-polyphenol-container"]'), head = q('[class^="vero-polyphenol-header"]'),
        main = q('[class^="vero-polyphenol-main"]'), imgW = q('[class^="vero-polyphenol-image-wrapper"]'),
        img = imgW && imgW.querySelector('img'), numW = q('[class^="vero-polyphenol-number-wrapper"]'),
        num = q('[class^="vero-polyphenol-number-"]:not([class*="wrapper"])'), label = q('[class^="vero-polyphenol-label"]'),
        feats = q('[class^="vero-polyphenol-features"]'), cta = q('[class^="vero-polyphenol-cta"]');
    if (!cont || !head || !img || !num || !numW || !main) return;

    var TARGET = 772, m = (num.textContent || '').match(/\d{3,}/); if (m && +m[0] > 99) TARGET = +m[0];
    var el = function (t, c, h) { var e = d.createElement(t); if (c) e.className = c; if (h) e.innerHTML = h; return e; };
    var mobile = w.matchMedia('(max-width: 749px)').matches;

    /* ---------- build ---------- */
    sec.classList.add('lx-pp');
    img.loading = 'eager';
    var track = el('div', 'lx-pp__track'), stage = el('div', 'lx-pp__stage');
    stage.appendChild(el('div', 'lx-pp__wm', '<span>POLYPHENOLS · ' + TARGET + ' MG/KG · EARLY HARVEST · POLYPHENOLS · ' + TARGET + ' MG/KG</span>'));
    stage.firstChild.setAttribute('aria-hidden', 'true');

    var ticks = '', N = 72;
    for (var i = 0; i < N; i++) ticks += '<line x1="200" y1="6" x2="200" y2="' + (i % 6 === 0 ? 22 : 15) + '" transform="rotate(' + (i * 360 / N) + ' 200 200)"/>';
    var hero = el('div', 'lx-pp__hero',
      '<div class="lx-pp__halo"></div>' +
      '<svg class="lx-pp__ring" viewBox="0 0 400 400" aria-hidden="true"><g class="lx-pp__ticks">' + ticks + '</g>' +
      '<circle class="lx-pp__base" cx="200" cy="200" r="186"/><circle class="lx-pp__inner" cx="200" cy="200" r="150"/>' +
      '<circle class="lx-pp__arc" cx="200" cy="200" r="186" pathLength="1" transform="rotate(-90 200 200)"/>' +
      '<g class="lx-pp__head"><circle cx="200" cy="14" r="9" class="lx-pp__glow"/><circle cx="200" cy="14" r="3.6"/></g></svg>' +
      '<div class="lx-pp__parts"></div><div class="lx-pp__floor"></div>');
    var parts = hero.querySelector('.lx-pp__parts');
    var hex = '<svg viewBox="0 0 24 24"><path d="M12 2.5l8.2 4.75v9.5L12 21.5l-8.2-4.75v-9.5z"/></svg>';
    for (var j = 0; j < 18; j++) {
      var a = (j * 137.5) % 360, r0 = .5 + ((j * 37) % 40) / 100, isHex = j % 3 === 0;
      var pt = el('i', 'lx-pp__pt' + (isHex ? ' lx-pp__pt--hex' : ''), isHex ? hex : '');
      pt.style.cssText = '--a:' + a.toFixed(1) + ';--r0:' + r0.toFixed(2) + ';--dr:' + (.22 + (j % 5) * .07).toFixed(2) + ';--s:' + (isHex ? 16 + (j % 4) * 4 : 3 + (j % 4) * 2) + 'px;--o:' + (.45 + (j % 3) * .2).toFixed(2) + ';--sp:' + (j % 2 ? 1 : -1);
      parts.appendChild(pt);
    }
    var bottle = el('div', 'lx-pp__bottle'), bob = el('div', 'lx-pp__bob');
    var imw = el('span', 'lx-pp__imw'); imw.appendChild(img); imw.appendChild(el('i', 'lx-pp__sheen'));
    var setSrc = function () { var u = img.currentSrc || img.src; if (u) imw.style.setProperty('--src', 'url("' + u + '")'); };
    if (img.complete) setSrc(); else img.addEventListener('load', setSrc);
    bob.appendChild(imw); bottle.appendChild(bob); hero.appendChild(bottle);

    var read = el('div', 'lx-pp__read');
    num.innerHTML = '<span class="lx-pp__n">0</span><span class="lx-pp__u">x</span>';
    num.setAttribute('aria-label', '10x');
    if (label) { label.textContent = 'יותר פוליפנולים משמן ממוצע'; label.classList.add('lx-pp__lbl'); }
    read.appendChild(numW);
    numW.appendChild(el('div', 'lx-pp__ver', '<svg viewBox="0 0 24 24" aria-hidden="true"><path pathLength="1" d="M12 2.8l7.4 3.1v5.4c0 4.6-3.1 8.3-7.4 9.9-4.3-1.6-7.4-5.3-7.4-9.9V5.9z"/><path pathLength="1" d="M8.4 12.1l2.5 2.5 4.8-5"/></svg><span>LAB VERIFIED · ' + TARGET + ' MG/KG</span>'));
    var bar = el('div', 'lx-pp__bar', '<i></i>'); bar.setAttribute('aria-hidden', 'true');

    stage.appendChild(head); stage.appendChild(hero); stage.appendChild(read); stage.appendChild(bar);
    track.appendChild(stage);
    var after = el('div', 'lx-pp__after');
    if (feats) after.appendChild(feats);
    if (cta) after.appendChild(cta);
    cont.insertBefore(track, main); cont.insertBefore(after, main);
    main.parentNode.removeChild(main);
    [head, feats, cta].forEach(function (e) { if (e) e.classList.add('visible'); });

    /* ---------- refs ---------- */
    var nEl = num.querySelector('.lx-pp__n'), arc = hero.querySelector('.lx-pp__arc'), headG = hero.querySelector('.lx-pp__head'),
        tickEls = hero.querySelectorAll('.lx-pp__ticks line'), halo = hero.querySelector('.lx-pp__halo'),
        floor = hero.querySelector('.lx-pp__floor'), wm = stage.querySelector('.lx-pp__wm span'), barI = bar.firstChild;

    var clamp = function (v) { return v < 0 ? 0 : v > 1 ? 1 : v; };
    var seg = function (t, a, b) { return clamp((t - a) / (b - a)); };
    var inOut = function (k) { return k < .5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2; };
    var out = function (k) { return 1 - Math.pow(1 - k, 3); };

    var lastN = -1, lastLit = -1, done = false, R = 0;
    function measure() { R = hero.querySelector('.lx-pp__ring').getBoundingClientRect().width / 2; hero.style.setProperty('--R', R.toFixed(1) + 'px'); }

    function frame() {
      ticking = false;
      var r = track.getBoundingClientRect(), H = w.innerHeight, L = r.height;
      if (!L) return;
      var t = clamp((H - r.top) / L);
      var pin = H / L;
      var kb = inOut(seg(t, pin * .35, pin + .12));
      var kc = out(seg(t, pin + .02, .9));
      var kp = seg(t, pin * .6, 1);

      bottle.style.transform = 'translate3d(0,' + ((1 - kb) * 16).toFixed(2) + '%,0) rotate(' + (16 - 29 * kb).toFixed(2) + 'deg) scale(' + (.82 + .18 * kb).toFixed(3) + ')';
      halo.style.transform = 'translate(-50%,-50%) scale(' + (.45 + .7 * kb + .12 * kc).toFixed(3) + ')';
      halo.style.opacity = (.25 + .75 * kb).toFixed(3);
      floor.style.opacity = (kb * .9).toFixed(3);
      floor.style.transform = 'translateX(-50%) scaleX(' + (.55 + .45 * kb).toFixed(3) + ')';
      hero.style.setProperty('--kp', kp.toFixed(3));
      hero.style.setProperty('--spin', (t * 70).toFixed(1));
      hero.style.setProperty('--ko', (seg(t, pin * .5, pin + .08) * (1 - seg(t, .93, 1) * .4)).toFixed(3));
      arc.style.strokeDashoffset = (1 - kc).toFixed(4);
      headG.setAttribute('transform', 'rotate(' + (kc * 360).toFixed(2) + ' 200 200)');
      headG.style.opacity = kc > .002 && kc < .999 ? 1 : 0;
      wm.style.transform = 'translate3d(' + ((t - .5) * (mobile ? 90 : 40)).toFixed(2) + '%,0,0)';
      barI.style.transform = 'scaleX(' + kc.toFixed(4) + ')';

      var n = kc >= .999 ? '10' : (10 * kc).toFixed(1);
      if (n !== lastN) { nEl.textContent = n; lastN = n; }
      var lit = Math.round(kc * N);
      if (lit !== lastLit) { for (var i = 0; i < N; i++) tickEls[i].classList.toggle('on', i < lit); lastLit = lit; }
      var dn = kc >= .999;
      if (dn !== done) { done = dn; stage.classList.toggle('is-done', dn); }
      stage.classList.toggle('is-live', t > pin * .2);
    }

    var ticking = false, active = false;
    function kick() { if (!ticking && active) { ticking = true; requestAnimationFrame(frame); } }
    if ('IntersectionObserver' in w) {
      new IntersectionObserver(function (es) { active = es[0].isIntersecting; if (active) { measure(); kick(); } }, { rootMargin: '25% 0px' }).observe(track);
    } else { active = true; }
    w.addEventListener('scroll', kick, { passive: true });
    w.addEventListener('resize', function () { mobile = w.matchMedia('(max-width: 749px)').matches; measure(); kick(); }, { passive: true });
    measure(); frame();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
